import React, { ReactNode } from 'react';
import { LazyMotion, m } from 'framer-motion';

const loadFeatures = () => import('./features.js').then(res => res.default);

type Props = {
  children: ReactNode;
};

const MotionLazyContainer: React.FC<Props> = ({ children }) => {
  return (
    <LazyMotion strict features={loadFeatures}>
      <m.div style={{ height: '100%' }}> {children} </m.div>
    </LazyMotion>
  );
};

export default MotionLazyContainer;
